import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, PlayCircle } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export const AssignedLessonsStrip = ({ childId }) => {
  const { api } = useAuth();
  const [lessons, setLessons] = useState([]);

  useEffect(() => {
    api.get(`/lessons/assigned/${childId}`).then((r) => setLessons(r.data.lessons || [])).catch(() => {});
  }, [childId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!lessons.length) return null;
  return (
    <div className="mb-6" data-testid="assigned-lessons-strip">
      <p className="font-fredoka font-bold text-slate-800 mb-2">Lessons for you</p>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {lessons.map((l) => (
          <Link key={l.id} to={`/lesson/${childId}/${l.id}`} data-testid={`assigned-lesson-${l.id}`}
            className="min-w-[180px] rounded-2xl bg-white border-2 border-amber-200 hover:border-amber-400 hover:-translate-y-0.5 transition-all p-3 shadow-sm">
            <div className="text-2xl mb-1 truncate">{(l.illustration || '✨').slice(0, 6)}</div>
            <p className="font-semibold text-sm text-slate-800 truncate">{l.title}</p>
            <p className="text-xs mt-1 flex items-center gap-1 text-slate-500">
              {l.status === 'completed' ? <><Check className="w-3 h-3 text-teal-600" /> Done · tap to replay</> : <><PlayCircle className="w-3 h-3 text-amber-600" /> New</>}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AssignedLessonsStrip;
